import React from "react";
import { Paper, Box, Typography, Stack, Chip } from "@mui/material";
import {
  PersonOutline,
  ScheduleOutlined,
  CalendarTodayOutlined,
  SchoolOutlined,
} from "@mui/icons-material";
import {
  textPrimary,
  textSecondary,
  softShadow,
  primaryColor,
  successColor,
  infoColor,
  color1,
} from "../../../constants/consts";

export default function EduCard({ edu }) {
  const {
    title = "-",
    desc = "",
    supporter = "-",
    duration = "",
    eduDate = "-",
  } = edu || {};

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        boxShadow: softShadow,
        border: "1px solid",
        borderColor: "rgba(0,0,0,0.06)",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.25s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: `0 10px 24px ${primaryColor}22`,
          borderColor: `${primaryColor}44`,
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: 4,
          height: "100%",
          backgroundColor: successColor,
        },
      }}
    >
      {/* Başlık + ikon */}
      <Stack direction="row" alignItems="flex-start" spacing={1.5}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: 2,
            flexShrink: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: `${successColor}1A`,
            color: successColor,
          }}
        >
          <SchoolOutlined fontSize="small" />
        </Box>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="subtitle1"
            fontWeight={700}
            color={textPrimary}
            sx={{ lineHeight: 1.3, mb: 0.5 }}
          >
            {title}
          </Typography>
          {desc && (
            <Typography
              variant="body2"
              color={textSecondary}
              sx={{
                lineHeight: 1.55,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {desc}
            </Typography>
          )}
        </Box>
      </Stack>

      {/* Alt satır: eğitmen / süre / tarih */}
      <Stack
        direction="row"
        spacing={1}
        flexWrap="wrap"
        useFlexGap
        sx={{ mt: 2, pt: 1.5, borderTop: `1px dashed ${color1}` }}
      >
        <Chip
          size="small"
          icon={<PersonOutline fontSize="small" />}
          label={supporter || "-"}
          sx={{
            backgroundColor: `${primaryColor}14`,
            color: primaryColor,
            fontWeight: 600,
            "& .MuiChip-icon": { color: primaryColor },
          }}
        />
        {duration && (
          <Chip
            size="small"
            icon={<ScheduleOutlined fontSize="small" />}
            label={duration}
            sx={{
              backgroundColor: `${infoColor}14`,
              color: infoColor,
              fontWeight: 600,
              "& .MuiChip-icon": { color: infoColor },
            }}
          />
        )}
        {eduDate && (
          <Chip
            size="small"
            icon={<CalendarTodayOutlined fontSize="small" />}
            label={eduDate}
            sx={{
              backgroundColor: "rgba(0,0,0,0.05)",
              color: textSecondary,
              fontWeight: 600,
              "& .MuiChip-icon": { color: textSecondary },
            }}
          />
        )}
      </Stack>
    </Paper>
  );
}
